import { Outlet } from "react-router-dom";

import "./Layout.scss";

const Layout = () => {
  return (
    <main className="layout-root">
      <Outlet />
    </main>
  );
};
export default Layout;
